module.exports = __webpack_public_path__ + "static/Dana-49b2e5efee276a4820d5c0d82dab27fd.svg";